const useExtractEmail = (inputString: string) => {
  const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
  const match = inputString.match(emailPattern);
  if (match) {
    const [before, after] = inputString.split(match[0]);
    return { email: match[0], beforeEmail: before, afterEmail: after };
  }
  return { email: null, beforeEmail: null, afterEmail: null };
};

export default useExtractEmail;
